import Employee from "../../../../src/components/Blog/Post/WNIP/Employee";
import Meetup, { MeetupList } from "../../../../src/components/Blog/Post/WNIP/Meetups";
import * as React from 'react';
export default {
  Employee,
  Meetup,
  MeetupList,
  React
};